import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { CodigosTransaccionesConstant, OrigenesContabilidadConstant } from 'constants/index'

import * as PlantillaContabilidadService from 'services/plantillaContabilidad.service'

const portletBreadcrumbs = [{ name: 'Plantillas' }]

const tableHeaderRows = [{ label: 'DESCRIPCION' }, { label: 'ORIGEN' }, { label: 'CUENTA CONTABLE SOLES' }, { label: '', width: 60 }]

const ListaPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const clickNuevo = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.PLANTILLASCONTABILIDAD_NUEVO}`)
  }, [history])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.PLANTILLASCONTABILIDAD_NUEVO}/${_id}`)
    },
    [history]
  )

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await PlantillaContabilidadService.eliminarxId(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado!')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )
  return (
    <Portlet>
      <Portlet.Header title='Plantillas' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevo }]} />
      <Portlet.Body>
        <Table.ServerSide
          useNest={true}
          ref={tablaRef}
          url='/plantillas-contabilidad'
          headRows={tableHeaderRows}
          rowTemplate={row => (
            <Table.Row key={row._id}>
              <Table.Cell>{row.descripcion || '--'}</Table.Cell>
              <Table.Cell>{row.origen ? OrigenesContabilidadConstant.__dictionary[row.origen].nombre : '--'}</Table.Cell>
              <Table.Cell>{row.cuentaContableSoles || '--'}</Table.Cell>
              <Table.Cell>
                <Table.Dropdown>
                  {({ handleClose }) => [
                    <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                      Editar
                    </Table.Dropdown.Item>,
                    <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                      Eliminar
                    </Table.Dropdown.Item>
                  ]}
                </Table.Dropdown>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ListaPage)
